/* 🤖 this file was generated by script */
export const wsolidiconFaceNeutral = {
  name: 'face_neutral',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22m1.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M7 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m.5-6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
